import React from 'react';
import { SortBySelect } from './SortBySelect';
import { useGoogleSearchContext } from '../../../components/search/GoogleInstantSearch';
import { baseConfig } from '../../../config/algolia';
import { SORT_DEFAULT_LABEL } from './constants';
import type { SortOrder } from '../../../types/search';

const { sort_orders } = baseConfig as { sort_orders?: Array<SortOrder> };

const GoogleSortByContainer = () => {
  const { state, setSort } = useGoogleSearchContext();

  const items = [
    { value: '', label: SORT_DEFAULT_LABEL },
    ...(sort_orders ?? []).flatMap((so: SortOrder) =>
      [
        so.asc?.active ? { value: `${so.key}_asc`, label: so.asc.title } : null,
        so.desc?.active ? { value: `${so.key}_desc`, label: so.desc.title } : null,
      ].filter(Boolean)
    ),
  ];

  const currentValue = state.sortBy ? `${state.sortBy}_${state.order ?? 'asc'}` : '';

  const handleChange = (value: string) => {
    if (!value) {
      setSort(undefined, undefined);
    } else {
      const parts = value.split('_');
      const order = parts.pop() as 'asc' | 'desc';
      setSort(parts.join('_'), order);
    }
  };

  return (
    <div className="sortby-container">
      <span className="sort-title">Sort by:</span>
      <SortBySelect items={items} currentValue={currentValue} onClick={() => {}} onChange={handleChange} />
    </div>
  );
};

export default GoogleSortByContainer;
